export const DRAG_TYPE = {
  IMAGE: "smartupload-image",
  VARIANT: "smartupload-variant",
  REMOVED_IMAGE: "smartupload-removed",
  REMOVED_SECTION: "smartupload-removed-section",
} as const;

export type ImageDragData = {
  type: typeof DRAG_TYPE.IMAGE;
  imageId: string;
  productIndex: number;
  variantId: string;
  imageIndex: number;
  productUrl: string;
};

export type VariantDropData = {
  type: typeof DRAG_TYPE.VARIANT;
  productIndex: number;
  variantId: string;
};

export type RemovedImageDragData = {
  type: typeof DRAG_TYPE.REMOVED_IMAGE;
  imageId: string;
  productUrl: string;
};

export type RemovedSectionDropData = {
  type: typeof DRAG_TYPE.REMOVED_SECTION;
};

export type AnyDragData = ImageDragData | RemovedImageDragData;
export type AnyDropData = VariantDropData | RemovedSectionDropData | ImageDragData;
